import React from 'react';
import WI_StatuteTOC from "../../../images/WI-statute-TOC.png";
import Modal from "../../Common/Modals/Modal";
import StyledImageFluid from "../Image.styled";
import Button from "../../Common/Buttons/Button";

const ContentDatabaseManagementModalButton = () => {

    const [isOpen, setIsOpen] = React.useState(false);

    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
    };

    return (
        <div>
            <Button type="button" className="btn btn-primary" onClick={showModal}>Read more...</Button>
            <Modal id="contentDatabaseManagementModal"
                   title="Content &amp; Database Management"
                   onClose={hideModal}
                   show={isOpen}>
                <StyledImageFluid src={WI_StatuteTOC} alt="WI Statutory TOC" rounded borderDarkgunmetal/>
                <p><strong>Software and data engineering</strong> experience in the legal content and publishing
                    industry providing document management and editorial capabilities to internal users processing
                    statutory and regulatory material.</p>
                <ul>
                    <li>Responsible for implementing, enhancing, and supporting several different proprietary
                        hierarchical, topical, and editorial applications used by internal legal attorneys and
                        compliance staff.
                        <ul>
                            <li>The hierarchical and topical application systems served as an index and controlling
                                structure into the content.
                            </li>
                            <li>The editorial applications served as an xml document repository allowing users direct
                                content manipulation from within a web browser.
                            </li>
                        </ul>
                    </li>
                    <li>Created relational database schemas and object relational mappings to be used to develop
                        applications for the legal content and publishing business domain.
                    </li>
                    <li>Implemented and tested webservices built using the REST architectural style using both JSON and
                        XML documents to communicate with the underlying java\groovy based services.
                        <ul>
                            <li>These web services were part of the non-editorial publishing pathways.</li>
                            <li>The goal of non-editorial publishing pathways was to automate value-add content without
                                the need for user intervention.
                            </li>
                        </ul>
                    </li>
                </ul>
            </Modal>
        </div>
    );
}

export default ContentDatabaseManagementModalButton;